exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colorTecni {\r\n    color: #333;\r\n}\r\n\r\n\r\n/*label {\r\n    text-align: right;\r\n    width: 146px;\r\n}*/\r\n\r\n.txtGiroNegocio {\r\n    text-transform: uppercase;\r\n    width: 580px;\r\n}\r\n\r\n.txtGrande {\r\n    text-transform: uppercase;\r\n    width: 320px !important;\r\n}\r\n\r\n.txtNombres {\r\n    text-transform: uppercase;\r\n    width: 320px;\r\n}\r\n\r\n.txtApellidos {\r\n    text-transform: uppercase;\r\n    width: 290px;\r\n}\r\n\r\n.txtInput {\r\n    width: 300px !important;\r\n}\r\n\r\n.tabTecni .nav-tabs li.active a {\r\n    color: #A14950;\r\n    background-color: #EDEDED;\r\n}\r\n\r\n.ui-inputtext {\r\n    width: 230px !important;\r\n}\r\n\r\n.p {\r\n    color: red;\r\n    border: none;\r\n    font-size: 12px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/datosGenerales/datos-generales-empresa.style.css
// module id = ../../../../../src/app/views/empresas/datosGenerales/datos-generales-empresa.style.css
// module chunks = 0